/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  API_URL: '/api',
  // API_URL: 'http://54.39.217.153/api',
  // WS_URL: 'ws://ip_address:8090' format for non-ssl ip-address
  // WS_URL: 'wss://domain/wss/:8080' format for ssl domain
  // WS_URL: '' empty format for build or deploy to server
  WS_URL: '',
  // WS_URL: 'ws://54.39.217.153:8090',
};
